import React from 'react';
import { Checkbox } from '@mui/material';
import CheckedXIcon from '@shared/components/CheckedXIcon';

/**
 * @typedef {object} WeekCheckboxWeek
 * @property {number} id
 * @property {boolean} checked
 * @property {boolean} disabled
 */

/**
 * @typedef {object} WeekCheckboxesProps
 * @property {(week: WeekCheckboxWeek) => void | Promise<void>} [removeUnavailablePeriod]
 * @property {(week: WeekCheckboxWeek) => void | Promise<void>} [addNewUnavailablePeriod]
 * @property {WeekCheckboxWeek[]} [weeks]
 */

/**
 * @param {WeekCheckboxesProps} props
 */
const WeekCheckboxes = props => {
  const { removeUnavailablePeriod, addNewUnavailablePeriod, weeks = [] } = props;

  const handleChange = async (checked, week) => {
    checked ? await removeUnavailablePeriod(week) : await addNewUnavailablePeriod(week);
  };

  return (
    <div className='week-checkboxes' role='week-checkboxes'>
      <span className='title'>Availability</span>
      {weeks.map(week => {
        return (
          <div key={week.id} className='checkbox-wrapper'>
            <Checkbox
              id={'availability-checkbox-' + week.id}
              size='medium'
              checkedIcon={<CheckedXIcon size='medium' />}
              color='default'
              disableRipple
              disabled={week.disabled}
              checked={week.checked}
              onChange={event => {
                handleChange(event.target.checked, week);
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default WeekCheckboxes;
